var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFD3A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8438 41.6544L32.6461 42.7811V41.2994L32.3115 40.9599H29.9085V42.6885V43.9077H32.4788L35.6422 42.5187L36.8438 41.6544Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.156 41.6544L27.2624 42.7811V41.2994L27.6122 40.9599H30V42.6885V43.9077H27.4297L24.2662 42.5187L23.156 41.6544Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3119 38.4437L32.6465 41.299L32.2206 40.9594H27.7796L27.2625 41.299L27.6123 38.4437L28.2967 38.0116L31.7187 38.0888L32.3119 38.4437Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.624 19.0741L32.5708 23.9358L31.6279 38.0885H28.2971L27.2629 23.9358L25.377 19.0741H34.624Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.597 29.7547L46 36.7925L40.0077 36.4375H36.1598V33.3971L36.3271 27.1618L37.194 27.8409L43.597 29.7547Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0635 30.5419L32.0522 30.7116L32.8278 34.354L36.1586 33.4897L39.0635 30.5419Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0635 30.6188L36.1586 33.3968V36.1749L39.0635 30.6188Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1592 33.4892L32.7372 34.3534L31.6269 38.0884L32.4026 38.5206L36.1592 36.2672V33.4892Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1593 36.2678L36.8438 41.6542L32.3115 38.444L36.1593 36.2678Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0554 30.7115L31.63 38.0888L32.9062 34.323L32.0554 30.7115Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0996 36.3604L36.1605 36.2678L36.8449 41.6542L40.0996 36.3604Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1141 44L36.8442 41.6541L40.0989 36.3603L46 36.7924L44.1141 44Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5693 23.9361L36.2498 27.0691L39.0635 30.5417L32.0522 30.8041L32.5693 23.9361Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8438 41.6541L32.3115 38.4438L32.6461 41.2219V42.7807L35.7335 42.1788L36.8438 41.6541Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1561 41.6541L27.6123 38.4438L27.2625 41.2219V42.7807L24.1903 42.1788L23.1561 41.6541Z",
    fill: "#DFCEC3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9403 32.2701L32.9974 34.2765L36.3281 33.3967L33.9403 32.2701Z",
    fill: "#393939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2074 15L32.5725 23.9361L34.5345 19.0745L44.2074 15Z",
    fill: "#E88F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2054 15L45.7415 19.769L44.8898 24.9856L45.4829 25.3252L44.6312 26.1123L45.3156 26.7142L44.3727 27.5785L44.9658 28.1032L43.597 29.8318L37.1788 27.8409C34.0458 25.2943 32.4945 23.9979 32.5553 23.9361C32.6162 23.8744 36.5096 20.8957 44.2054 15Z",
    fill: "#8E5A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.403 29.7547L14 36.7925L19.9923 36.4375H23.8402V33.3971L23.6729 27.1618L22.8212 27.8409L16.403 29.7547Z",
    fill: "#F89D35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9365 30.5419L27.9478 30.7116L27.1874 34.354L23.8414 33.4897L20.9365 30.5419Z",
    fill: "#D87C30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9365 30.6188L23.8414 33.3968V36.1749L20.9365 30.6188Z",
    fill: "#EA8D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8408 33.4892L27.2628 34.3534L28.3731 38.0884L27.6126 38.5206L23.8408 36.2672V33.4892Z",
    fill: "#F89D35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8407 36.2678L23.1562 41.6542L27.6125 38.5211L23.8407 36.2678Z",
    fill: "#EB8F35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9456 30.7115L28.371 38.0888L27.0947 34.323L27.9456 30.7115Z",
    fill: "#EA8E3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9023 36.3604L23.8415 36.2678L23.1571 41.6542L19.9023 36.3604Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8859 44L23.1558 41.6541L19.9011 36.3603L14 36.7924L15.8859 44Z",
    fill: "#EB8F35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4307 23.9361L23.7502 27.0691L20.9365 30.5417L27.9478 30.8041L27.4307 23.9361Z",
    fill: "#E8821E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0607 32.2701L27.0036 34.2765L23.6729 33.3967L26.0607 32.2701Z",
    fill: "#393939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7955 15L27.4303 23.9361L25.4683 19.0745L15.7955 15Z",
    fill: "#E88F35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7946 15L14.2585 19.769L15.1102 24.9856L14.5171 25.3252L15.3688 26.1123L14.6844 26.7142L15.6273 27.5785L15.0342 28.1032L16.403 29.8318L22.8212 27.8409C25.9542 25.2943 27.5055 23.9979 27.4447 23.9361C27.3838 23.8744 23.5056 20.8957 15.7946 15Z",
    fill: "#8E5A30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.426833f1.svg";
export { ForwardRef as ReactComponent };